import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/backend/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const submitInquiry = async (data) => {
  const response = await api.post('/inquiry', data);
  return response.data;
};

export const submitBooking = async (data) => {
  const response = await api.post('/booking', data);
  return response.data;
};

export default api;
